{
  "replaceMessage": "Suelte el archivo para reemplazar"
}
